import * as React from 'react';
import { IonApp } from '@ionic/react';
import { ThemeProvider } from 'oasis-os-theming';
import { getCookie } from 'oasis-os-utils';
import { Analytics, readGlobal } from 'oasis-os-common';
import { ContentfulApp } from '../../../types';
import StandardLayouts from './StandardLayouts';
import { getSilentInfo } from '../../../utils/getSilentInfo';
import { getCookieAnalytics } from '../../../utils/getCookieAnalytics';

export interface StandardProps {
  config: ContentfulApp;
}

const Standard: React.FC<StandardProps> = ({ config }: StandardProps) => {
  const { fields: appConfig } = config;
  const analytics: ContentfulApp['fields']['config']['fields']['analytics'] = getSilentInfo(
    'analytics',
    appConfig?.config?.fields?.analytics,
  );
  const analyticsEnabled = getCookieAnalytics();

  const [cookieStatus, setCookieStatus] = React.useState<boolean>(false);

  React.useEffect(() => {
    const cookieName = readGlobal('$.global.value.functionalConfig.sfrCookie.name') as string;
    const cookieVal = readGlobal('$.global.value.functionalConfig.sfrCookie.value');
    const cookieCheckInterval = readGlobal(
      '$.global.value.functionalConfig.sfrCookie.interval',
    ) as number;
    const intervalId = setInterval(() => {
      const cookieVlaue = getCookie(cookieName);
      if (cookieVlaue !== '') {
        if (cookieVlaue === cookieVal) {
          setCookieStatus(true);
          clearInterval(intervalId);
        } else {
          clearInterval(intervalId);
        }
      }
    }, cookieCheckInterval);
  }, []);

  return (
    <ThemeProvider icons={appConfig?.icons} locale={appConfig?.locale}>
      <IonApp className="pwa" data-testid="ion-app">
        <StandardLayouts />
        {/* TODO replace this with feature-analytics and load it only if analytics is configured */}
        {appConfig?.config?.fields?.analytics && cookieStatus && <Analytics config={analytics} isEnabled={analyticsEnabled}/>}
      </IonApp>
    </ThemeProvider>
  );
};
export default Standard;